import { useState, MouseEvent } from 'react';
import { TextLink } from 'darrius';
import styles from './Recomendations.module.scss';
import { CleanCard } from '../../CleanCard';

interface IRecomendationItem {
  name: string;
  rating: number;
  date?: string;
  description: string;
}

interface IRecomendationsProps {
  limit: number;
  recomendations: {
    id: string;
    title: string;
    items: IRecomendationItem[];
    totalPage: number;
  };
}

const DEFAULT_PAGE = 1;
const LIMIT_RECOMENDATIONS = 3;

const buttonTextShowLess = 'Exibir menos';
const buttonTextShowMore = 'Exibir mais comentários';

export const Recomendations = ({
  recomendations,
  limit = LIMIT_RECOMENDATIONS,
}: IRecomendationsProps) => {
  const { id, items, title } = recomendations;
  const [pageCount, setPageCount] = useState(DEFAULT_PAGE);
  const [recomendationsList, setRecomendationsList] = useState(
    items.slice(0, limit)
  );
  const allRecomendations = items;

  const remainingRecomendations =
    allRecomendations.length - recomendationsList.length;
  const showButton = allRecomendations.length > limit;

  async function handleShowNewRecomendation(evt: MouseEvent) {
    evt.preventDefault();
    const currentPage = pageCount + 1;
    setRecomendationsList(allRecomendations.slice(0, currentPage * limit));
    setPageCount(currentPage);
  }

  function handleResetInitialRecomendation(evt: MouseEvent) {
    evt.preventDefault();
    setPageCount(DEFAULT_PAGE);
    setRecomendationsList((oldState) => oldState.slice(0, limit));
  }

  return (
    <section className={`recomendations ${styles.recomendations}`} id={id}>
      <div className={`recomendations__list`}>
        {recomendationsList.map((recomendation, index) => (
          <CleanCard.Root key={index}>
            <CleanCard.Title>
              <strong className={styles.name}>{recomendation.name}</strong>
              {recomendation.date && (
                <span className={styles.date}>, {recomendation.date}</span>
              )}
            </CleanCard.Title>
            <CleanCard.Rating ratingNumber={recomendation.rating} />
            {recomendation.description && (
              <CleanCard.Description description={recomendation.description} />
            )}
          </CleanCard.Root>
        ))}
      </div>
      {showButton && remainingRecomendations <= 0 ? (
        <TextLink
          text={buttonTextShowLess}
          url="#recomendations"
          onClick={handleResetInitialRecomendation}
          className={`recommendations__show-less ${styles.recommendations__button}`}
        />
      ) : null}
      {showButton && remainingRecomendations > 0 ? (
        <TextLink
          text={`${buttonTextShowMore} (${remainingRecomendations})`}
          url="#"
          onClick={handleShowNewRecomendation}
          className={`recommendations__show-more ${styles.recommendations__button}`}
        />
      ) : null}
    </section>
  );
};
